import React from 'react';
import MotorCurrencySelect from './MotorCurrencySelect';

const StorZebraSettings = React.memo(({
  activeTypeTab,
  storExtras,
  setStorExtras,
  zebraExtras,
  setZebraExtras
}) => {
  const isStor = activeTypeTab === 'stor';
  const extras = isStor ? storExtras : zebraExtras;
  const setExtras = isStor ? setStorExtras : setZebraExtras;

  return (
    <>
      <div className="settings-card">
        <div className="settings-card-title">
          <i className="fas fa-cogs"></i>
          <h4>Motor Ayarları ({isStor ? 'Stor' : 'Zebra'})</h4>
        </div>
        <div className="settings-grid settings-grid-motor">
          <MotorCurrencySelect
            value={extras.motorCurrency}
            onChange={(e) => setExtras(p => ({ ...p, motorCurrency: e.target.value }))}
          />
          <div className="form-group">
            <label>Motor Ücreti</label>
            <input type="number" value={extras.motorPrice} onChange={(e) => setExtras(p => ({ ...p, motorPrice: e.target.value }))} />
          </div>
        </div>
      </div>

      <div className="settings-card">
        <div className="settings-card-title">
          <i className={isStor ? 'fas fa-cog' : 'fas fa-stream'}></i>
          <h4>{isStor ? 'Stor' : 'Zebra'} Perde Ücret Ayarları (₺)</h4>
        </div>
        <div className="settings-grid">
          <div className="form-group">
            <label>Jumbo Sistem</label>
            <input type="number" value={extras.jumbo} onChange={(e) => setExtras(p => ({ ...p, jumbo: e.target.value }))} />
          </div>
          <div className="form-group">
            <label>Alt Etek Dilim</label>
            <input type="number" value={extras.altEtekDilim} onChange={(e) => setExtras(p => ({ ...p, altEtekDilim: e.target.value }))} />
          </div>
          <div className="form-group">
            <label>Kapalı Kasa</label>
            <input
              type="number"
              value={extras.kapaliKasa}
              onChange={(e) => setExtras(p => ({ ...p, kapaliKasa: e.target.value }))}
            />
          </div>
          {isStor && (
            <>
              <div className="form-group">
                <label>Alt Etek Lazer</label>
                <input type="number" value={extras.altEtekLazer} onChange={(e) => setExtras(p => ({ ...p, altEtekLazer: e.target.value }))} />
              </div>
              <div className="form-group">
                <label>Dekoratif Lama</label>
                <input type="number" value={extras.dekoratifLama} onChange={(e) => setExtras(p => ({ ...p, dekoratifLama: e.target.value }))} />
              </div>
              <div className="form-group">
                <label>Dekoratif Kasa</label>
                <input type="number" value={extras.dekoratifKasa} onChange={(e) => setExtras(p => ({ ...p, dekoratifKasa: e.target.value }))} />
              </div>
              <div className="form-group">
                <label>Alt Etek Beyaz İş</label>
                <input type="number" value={extras.altEtekBeyazIs} onChange={(e) => setExtras(p => ({ ...p, altEtekBeyazIs: e.target.value }))} />
              </div>
              <div className="form-group">
                <label>47&apos;lik Boru</label>
                <input type="number" value={extras.boru47} onChange={(e) => setExtras(p => ({ ...p, boru47: e.target.value }))} />
              </div>
              <div className="form-group">
                <label>47&apos;lik Mekanizma</label>
                <input type="number" value={extras.mekanizma47} onChange={(e) => setExtras(p => ({ ...p, mekanizma47: e.target.value }))} />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
});

export default StorZebraSettings;
